import { defineMessages } from '@edx/frontend-platform/i18n'

const messages = defineMessages({
  courses: {
    id: "pages.learning.courses",
    defaultMessage: "Courses",
    description: "Courses"
  },
  programs: {
    id: "pages.learning.programs",
    defaultMessage: "Programs",
    description: "Programs"
  },
  notes: {
    id: "pages.learning.notes",
    defaultMessage: "Notes",
    description: "Notes"
  },
  upcoming: {
    id: "pages.learning.upcoming",
    defaultMessage: "Upcoming",
    description: "Upcoming"
  },
  relevent: {
    id: "pages.learning.relevent",
    defaultMessage: "Relevent",
    description: "Relevent"
  },
  atoz: {
    id: "pages.learning.atoz",
    defaultMessage: "A to Z",
    description: "A to Z"
  },
  ztoa: {
    id: "pages.learning.ztoa",
    defaultMessage: "Z to A",
    description: "Z to A"
  },
  selectCourse: {
    id: "pages.learning.selectCourse",
    defaultMessage: "Select Course",
    description: "Select Course"
  },
  search: {
    id: "pages.learning.search",
    defaultMessage: "Search...",
    description: "Search"
  }
});

export default messages;